import { servicesData } from '../../../mocks/services';

export default function Services() {
  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start mb-16 gap-8">
          <div className="lg:w-1/2">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              Complete Property<br />
              Maintenance Solutions
            </h2>
          </div>
          <div className="lg:w-1/2">
            <p className="text-lg text-gray-600 leading-relaxed">
              We offer comprehensive property maintenance services to keep your home or business looking its best year-round. Our experienced team delivers quality results with attention to detail.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {servicesData.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-6 hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer group"
            >
              <div className={`w-16 h-16 rounded-full ${service.bgColor} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.name}
              </h3>
              
              <p className="text-gray-600 mb-4 leading-relaxed">
                {service.description}
              </p>
              
              <button className="text-orange-500 font-semibold flex items-center space-x-2 group-hover:space-x-3 transition-all cursor-pointer">
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}